/**
 * Whether a score is already recorded under a singer the game knows, which is the whole question the
 * rename on the high-score row exists to answer. It is only ever needed for a slot that had NO
 * profile: `singer-options.ts` is explicit that an unassigned slot keeps its "Player 2" fallback and
 * scores under it, and where a profile was assigned the recorded name is already right.
 *
 * A co-op score joins its two singers with ", " (see `results.tsx`), so both halves have to be
 * accounted for before the pair counts as named.
 */
export const isRecordedUnderAProfile = (scoreName: string, profileNames: string[]) => {
  const known = new Set(profileNames.map((profile) => profile.trim().toLowerCase()));
  const parts = scoreName
    .split(', ')
    .map((part) => part.trim())
    .filter(Boolean);

  return parts.length > 0 && parts.every((part) => known.has(part.toLowerCase()));
};
